export default __webpack_public_path__ + "static/media/zee.6c1b252a.webp";